import React from "react";
import ProjectForm from "./tabs/forms/ProjectForm";

const CreateProjectPage: React.FC = () => {

  return <ProjectForm  />;
};

export default CreateProjectPage;
